import { defineStore } from 'pinia'

interface State {
  isOpen: boolean
}

const INITIAL_STATE: State = {
  isOpen: false,
}

const useSupportStore = defineStore('support', {
  state: () => ({ ...INITIAL_STATE }),
  actions: {
    toggleIsOpen(isOpen: boolean) {
      this.isOpen = isOpen
    },
  },
})

export default useSupportStore
